<template>
  <div v-if="basemapDescription" class="tw:flexrow-0 tw:pointer-events-auto">
    <div
      v-if="!collapsed"
      class="tw:border tw:shadow-md tw:flexcenter tw:-mr-1 tw:border-gray-200 tw:bg-white/90 tw:text-xs tw:px-2 tw:rounded-l-base"
    >
      <basemap-attribution-text ref="attribution" :description="basemapDescription" />
    </div>
    <base-button type="map-control" icon="mdi-information-outline" size="sm" @click="collapsed = !collapsed" />
  </div>
</template>

<script>
import BasemapAttributionText from '@/components/BasemapAttributionText';
import { get } from 'vuex-pathify';

export default {
  name: 'BasemapAttribution',
  components: {
    BasemapAttributionText,
  },
  props: {
    basemap: {
      type: [Number, null],
    },
  },
  data: () => ({
    collapsed: false,
  }),
  watch: {
    basemap() {
      this.collapsed = false;
      this.$emit('onMap', map => this.assignCollapseListener(map));
    },
  },
  computed: {
    basemapDescription: get('layers/basemapLayers@:basemap.description'),
  },
  methods: {
    assignCollapseListener(mapContext) {
      mapContext.getView().once('change:center', () => (this.collapsed = true));
    },
    onMapInit() {
      this.$emit('onMap', map => map.once('rendercomplete', () => this.assignCollapseListener(map)));
    },
  },
  mounted() {
    this.onMapInit();
  },
};
</script>
